"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.injectController = exports.verifyMessageHash = exports.split = exports.computeAddress = exports.providers = void 0;
const starknet_1 = require("starknet");
const penpal_1 = require("@cartridge/penpal");
const device_1 = __importDefault(require("./device"));
const types_1 = require("./types");
const modal_1 = require("./modal");
exports.providers = {
    [starknet_1.constants.StarknetChainId.TESTNET]: new starknet_1.RpcProvider({
        nodeUrl: "https://starknet-goerli.g.alchemy.com/v2/FS0Fge2Rq1dlf2IsAIC_Ecy0UBp9uq51",
    }),
    [starknet_1.constants.StarknetChainId.MAINNET]: new starknet_1.RpcProvider({
        nodeUrl: "https://starknet-mainnet.g.alchemy.com/v2/-FbmIoy3U7xEqQhuhW6wkDB2uqfu0yKi",
    }),
};
class Controller {
    constructor(policies, options) {
        this.policies = [];
        this.url = "https://x.cartridge.gg";
        this.chainId = types_1.SupportedChainIds.TESTNET;
        if (policies) {
            this.policies = policies;
        }
        if (options === null || options === void 0 ? void 0 : options.chainId) {
            this.chainId = options.chainId;
        }
        if (options === null || options === void 0 ? void 0 : options.starterPackId) {
            this.starterPackId = options.starterPackId;
        }
        if (options === null || options === void 0 ? void 0 : options.url) {
            this.url = options.url;
        }
        if (typeof document === "undefined") {
            return;
        }
        this.modal = (0, modal_1.createModal)(this.url, () => {
            var _a;
            (_a = this.keychain) === null || _a === void 0 ? void 0 : _a.reset();
        });
        if (document.readyState === "complete" ||
            document.readyState === "interactive") {
            document.body.appendChild(this.modal.element);
        }
        else {
            document.addEventListener("DOMContentLoaded", () => {
                document.body.appendChild(this.modal.element);
            });
        }
        this.connection = (0, penpal_1.connectToChild)({
            iframe: this.modal.element.children[0],
        });
        this.connection.promise
            .then((keychain) => (this.keychain = keychain))
            .then(() => this.probe());
    }
    get account() {
        if (!this.accounts) {
            return;
        }
        return this.accounts[this.chainId];
    }
    ready() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            return (_a = this.connection) === null || _a === void 0 ? void 0 : _a.promise.then(() => this.probe()).then((res) => !!res, () => false);
        });
    }
    probe() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.keychain || !this.modal) {
                console.error("not ready for connect");
                return null;
            }
            try {
                const res = yield this.keychain.probe();
                if (res.code !== types_1.ResponseCodes.SUCCESS) {
                    return;
                }
                const { address } = res;
                this.accounts = {
                    [starknet_1.constants.StarknetChainId.MAINNET]: new device_1.default(exports.providers[starknet_1.constants.StarknetChainId.MAINNET], address, this.keychain, this.modal),
                    [starknet_1.constants.StarknetChainId.TESTNET]: new device_1.default(exports.providers[starknet_1.constants.StarknetChainId.TESTNET], address, this.keychain, this.modal),
                };
            }
            catch (e) {
                console.error(e);
                return;
            }
            return !!this.accounts[this.chainId];
        });
    }
    switchChain(chainId) {
        return __awaiter(this, void 0, void 0, function* () {
            const cid = chainId === starknet_1.constants.StarknetChainId.MAINNET
                ? types_1.SupportedChainIds.MAINNET
                : types_1.SupportedChainIds.TESTNET;
            if (this.chainId === cid) {
                return;
            }
            this.chainId = cid;
        });
    }
    // Register a new device key.
    register(username, credentialId, credential) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.keychain) {
                console.error("not ready for connect");
                return null;
            }
            return yield this.keychain.register(username, credentialId, credential);
        });
    }
    login(address, credentialId, options) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.keychain) {
                console.error("not ready for connect");
                return null;
            }
            return this.keychain.login(address, credentialId, options);
        });
    }
    provision(address, credentialId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.keychain) {
                console.error("not ready for connect");
                return null;
            }
            return this.keychain.provision(address, credentialId);
        });
    }
    issueStarterPack(id) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.keychain || !this.modal) {
                console.error("not ready for connect");
                return;
            }
            this.modal.open();
            try {
                if (!this.account) {
                    let response = yield this.keychain.connect(this.policies, undefined, this.chainId);
                    if (response.code !== types_1.ResponseCodes.SUCCESS) {
                        throw new Error(response.message);
                    }
                }
                return yield this.keychain.issueStarterPack(id);
            }
            catch (e) {
                console.log(e);
            }
            finally {
                this.modal.close();
            }
        });
    }
    showQuests(gameId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.keychain || !this.modal) {
                console.error("not ready for connect");
                return;
            }
            this.modal.open();
            try {
                return yield this.keychain.showQuests(gameId);
            }
            catch (e) {
                console.error(e);
            }
            finally {
                this.modal.close();
            }
        });
    }
    connect() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.accounts) {
                return this.accounts[this.chainId];
            }
            if (!this.keychain || !this.modal) {
                console.error("not ready for connect");
                return;
            }
            if (!!document.hasStorageAccess) {
                const ok = yield document.hasStorageAccess();
                if (!ok) {
                    yield document.requestStorageAccess();
                }
            }
            this.modal.open();
            try {
                let response = yield this.keychain.connect(this.policies, undefined, this.chainId);
                if (response.code !== types_1.ResponseCodes.SUCCESS) {
                    throw new Error(response.message);
                }
                response = response;
                this.accounts = {
                    [starknet_1.constants.StarknetChainId.MAINNET]: new device_1.default(exports.providers[starknet_1.constants.StarknetChainId.MAINNET], response.address, this.keychain, this.modal),
                    [starknet_1.constants.StarknetChainId.TESTNET]: new device_1.default(exports.providers[starknet_1.constants.StarknetChainId.TESTNET], response.address, this.keychain, this.modal),
                };
                if (this.starterPackId) {
                    yield this.keychain.issueStarterPack(this.starterPackId);
                }
                return this.accounts[this.chainId];
            }
            catch (e) {
                console.log(e);
            }
            finally {
                this.modal.close();
            }
        });
    }
    disconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.keychain) {
                console.error("not ready for disconnect");
                return null;
            }
            if (!!document.hasStorageAccess) {
                const ok = yield document.hasStorageAccess();
                if (!ok) {
                    yield document.requestStorageAccess();
                }
            }
            return yield this.keychain.disconnect();
        });
    }
    revoke(origin, policy) {
        if (!this.keychain) {
            console.error("not ready for disconnect");
            return null;
        }
        return this.keychain.revoke(origin);
    }
    approvals(origin) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.keychain) {
                console.error("not ready for disconnect");
                return;
            }
            return this.keychain.approvals(origin);
        });
    }
}
__exportStar(require("./types"), exports);
__exportStar(require("./errors"), exports);
var utils_1 = require("./utils");
Object.defineProperty(exports, "computeAddress", { enumerable: true, get: function () { return utils_1.computeAddress; } });
Object.defineProperty(exports, "split", { enumerable: true, get: function () { return utils_1.split; } });
Object.defineProperty(exports, "verifyMessageHash", { enumerable: true, get: function () { return utils_1.verifyMessageHash; } });
var inject_1 = require("./inject");
Object.defineProperty(exports, "injectController", { enumerable: true, get: function () { return inject_1.injectController; } });
exports.default = Controller;
//# sourceMappingURL=index.js.map